import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IFicha } from 'src/app/models/IFicha';
import { IFichaResumen } from 'src/app/models/IFichaResumen';
import { Lote } from 'src/app/models/Lote';
import { FichaService } from 'src/app/services/ficha.service';
import { ReporteGeneralFichaService } from 'src/app/services/ReporteGeneralFicha.service';
import { environment } from 'src/environments/environment';
import { ModalResumenFichaComponent } from '../ModalResumenFicha/ModalResumenFicha.component';
import { URL_WEB_SERVER } from '../../global/config';

declare var mapboxgl: any;

@Component({
  selector: 'app-mapbox-ficha-detalle',
  templateUrl: './mapbox-ficha-detalle.component.html',
  styleUrls: ['./mapbox-ficha-detalle.component.css'],
})
export class MapboxFichaDetalleComponent implements OnInit {

  infoLoteFromMapbox: any;
  infoFichaCatalogacion: IFicha;
  infoFichaResumen: IFichaResumen;
  urlWebServer: string = URL_WEB_SERVER.UrlWebServer;

  constructor(
    private _fichaService:FichaService,
    private _reporteGeneralFichaService: ReporteGeneralFichaService,
    private _modalService: NgbModal
  ) {}

  ngOnInit() {
    var overlay = document.getElementById('map-overlay');
    var popup = new mapboxgl.Popup({
      closeButton: false,
    });

    var popup_viewf = document.getElementById('popupf');
    //mapboxgl.accessToken = environment.mapBoxToken;
    mapboxgl.accessToken = "pk.eyJ1IjoiY29uc2FjaGFwaSIsImEiOiJjbGh6ZW1qc3QxMWJrM2RuemNmcW5sdmdzIn0.tGwGVzM39y1g19udePCPUw";
    if (!mapboxgl.supported()) {
      alert('Tu navegador no soporta Mapbox GL');
      return;
    }

    var map = new mapboxgl.Map({
      container: 'mapf',
      //style: 'mapbox://styles/zhyper/ckr6fw2040ws617pot375nci7',
      style: 'mapbox://styles/consachapi/cmj7lqqi7002k01ry5tiyh1ak',
      zoom: 14,
      center: [-71.978774, -13.516732],
    });

    map.on('load',  () => {
      console.log('Mapa base cargado, añadiendo capas personalizadas...');

      map.addSource('gchc-source',{
        type: 'vector',
        url: 'mapbox://zhyper.8qysgruh'
      });

      if (map.getLayer('gchc-lotes-layer')) {
        console.warn('La capa gchc-lotes-layer ya existe, removiendo...');
        map.removeLayer('gchc-lotes-layer');
      }

      map.addLayer({
        "id": "gchc-lotes-layer",
        "minzoom": 11,
        "paint": {
          "fill-color": "hsl(60, 49%, 53%)",
          'fill-outline-color': "hsl(0, 0%, 100%)",
          'fill-opacity': 0.0,
        },
        "type": "fill",
        'source': 'gchc-source',
        'source-layer': 'inmuebles_gchc_join_13_jul_20-7euy8t',

        "layout": {
          "visibility": "visible"
        }
      });

      map.on('click','gchc-lotes-layer',  (e) => {
        this.infoLoteFromMapbox = {
          "nroficha": e.features[0].properties.nroficha,
          "direccion": e.features[0].properties.direccion
        }
        console.log('INFO LOTE MAPBOX 2: ', this.infoLoteFromMapbox);

        new mapboxgl.Popup()
          .setLngLat(e.lngLat)
          .setDOMContent(popup_viewf)
          .addTo(map);

      });
    });

  }

  cargarFicha(nroficha: string) {
    this._fichaService.traerFichaArquitectonica(nroficha.substr(0, 10)).subscribe(ficha => {
      this.infoFichaCatalogacion = ficha[0];
    });
    this._reporteGeneralFichaService.traerReporteGeneralFicha(nroficha.substr(0,10)).subscribe(ficha => {
      this.infoFichaResumen = ficha[0];
      const modalRef = this._modalService.open(ModalResumenFichaComponent,{size: 'xl',})
      modalRef.componentInstance.ficha = ficha[0]
    })
  }
}
